import { render, staticRenderFns } from "./announcement.vue?vue&type=template&id=268ba793&scoped=true"
import script from "./announcement.vue?vue&type=script&lang=ts"
export * from "./announcement.vue?vue&type=script&lang=ts"
import style0 from "./announcement.vue?vue&type=style&index=0&id=268ba793&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268ba793",
  null
  
)

export default component.exports